/**
 * @generated SignedSource<<7a4b6bc523be2bb7471b8151d2b591b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UnifiedProfileInput = {
  aaid?: string | null;
  accountInternalId?: string | null;
  bio?: string | null;
  company?: string | null;
  id?: string | null;
  internalId?: string | null;
  isPrivate: boolean;
  linkedinUrl?: string | null;
  location?: string | null;
  products?: string | null;
  role?: string | null;
  updatedAt?: string | null;
  username?: string | null;
  websiteUrl?: string | null;
  xUrl?: string | null;
  youtubeUrl?: string | null;
};
export type EditProfileFormMutation$variables = {
  input: UnifiedProfileInput;
};
export type EditProfileFormMutation$data = {
  readonly unified: {
    readonly updateUnifiedProfile: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly errorType: string | null;
          readonly statusCode: number | null;
        } | null;
        readonly message: string | null;
      }> | null;
      readonly success: boolean;
      readonly unifiedProfile: {
        readonly aaid: string | null;
        readonly accountInternalId: string | null;
        readonly bio: string | null;
        readonly company: string | null;
        readonly id: string;
        readonly internalId: string | null;
        readonly isPrivate: boolean;
        readonly linkedinUrl: string | null;
        readonly location: string | null;
        readonly products: string | null;
        readonly role: string | null;
        readonly username: string | null;
        readonly websiteUrl: string | null;
        readonly xUrl: string | null;
        readonly youtubeUrl: string | null;
      } | null;
    } | null;
  } | null;
};
export type EditProfileFormMutation = {
  response: EditProfileFormMutation$data;
  variables: EditProfileFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UnifiedMutation",
    "kind": "LinkedField",
    "name": "unified",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "unifiedProfileInput",
            "variableName": "input"
          }
        ],
        "concreteType": "UnifiedProfilePayload",
        "kind": "LinkedField",
        "name": "updateUnifiedProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UnifiedMutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedMutationErrorExtension",
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "errorType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "statusCode",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "success",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UnifiedProfile",
            "kind": "LinkedField",
            "name": "unifiedProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "company",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bio",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "aaid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "linkedinUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "location",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountInternalId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "products",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "role",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "username",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "internalId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "websiteUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "xUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "youtubeUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditProfileFormMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditProfileFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "577e526b040bb229f6f8a717ba3b0bcd",
    "id": null,
    "metadata": {},
    "name": "EditProfileFormMutation",
    "operationKind": "mutation",
    "text": "mutation EditProfileFormMutation(\n  $input: UnifiedProfileInput!\n) {\n  unified {\n    updateUnifiedProfile(unifiedProfileInput: $input) {\n      errors {\n        message\n        extensions {\n          errorType\n          statusCode\n        }\n      }\n      success\n      unifiedProfile {\n        company\n        bio\n        id\n        aaid\n        linkedinUrl\n        location\n        accountInternalId\n        products\n        role\n        username\n        internalId\n        websiteUrl\n        xUrl\n        youtubeUrl\n        isPrivate\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2971949051bd50a34b306e64c8f2bc11";

export default node;
